import { render, staticRenderFns } from "./AvisoEvaluacionDocente.vue?vue&type=template&id=36358914&scoped=true&"
import script from "./AvisoEvaluacionDocente.vue?vue&type=script&lang=js&"
export * from "./AvisoEvaluacionDocente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36358914",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/views/AvisoEvaluacionDocente.vue
// module id = 590
// module chunks = 0